import React from "react";
import PropTypes from "prop-types";
import "@assets/css/common/style_modal.css";
import * as themes from "framer-motion/m";

/**
 * 테마 상세정보 모달 컴포넌트
 * @param {Object} props - 컴포넌트 속성
 * @param {boolean} props.isOpen - 모달 표시 여부
 * @param {Object} props.theme - 테마 정보
 * @param {Function} props.onClose - 모달 닫기 함수
 */
const ThemeDetailModal = ({ isOpen, theme, onClose }) => {
    if (!isOpen || !theme) return null;

    const branchNames = theme?.branches?.map((branch) => branch.branchName);
    const userName = theme?.createdBy?.name || '';

    return (
        <div className="modal-overlay active" id="theme-detail-modal">
            <div className="modal-container">
                <div className="modal-header">
                    <h3 className="modal-title">테마 상세정보</h3>
                    <button className="modal-close" onClick={onClose}>
                        &times;
                    </button>
                </div>
                <div className="modal-body">
                    <div className="detail-item-container">
                        <span className="detail-label">테마명</span>
                        <span className="detail-content">
                            {theme.themeName}
                        </span>
                    </div>
                    <div className="detail-item-container">
                        <span className="detail-label">사용 기간</span>
                        <span className="detail-content">
                            {theme.usagePeriod}
                        </span>
                    </div>
                    <div className="detail-item-container">
                        <span className="detail-label">사용 지점</span>
                        <span className="detail-content">
                            {branchNames && branchNames.length > 0
                                ? branchNames.join(", ")
                                : "없음"}
                        </span>
                    </div>
                    <div className="detail-item-container">
                        <span className="detail-label">배포 여부</span>
                        <span className="detail-content">
                            {theme.isDeployed ? "Y" : "N"}
                        </span>
                    </div>
                    <div className="detail-item-container">
                        <span className="detail-label">작성자</span>
                        <span className="detail-content">{userName}</span>
                    </div>
                </div>
                <div className="modal-footer">
                    <button
                        className="modal-btn modal-btn-primary"
                        onClick={onClose}
                    >
                        확인
                    </button>
                </div>
            </div>
        </div>
    );
};

ThemeDetailModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    theme: PropTypes.object,
    onClose: PropTypes.func.isRequired,
};

export default ThemeDetailModal;
